(() => {
  const checkout = document.querySelector(".circular-checkout");
  const thankyou = document.querySelector(".circular-thankyou");
  //const tokenString = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiNmY4NjA1NGVmM2EwYmQ5YTc0ZjE0Nzk3Y2MyNDMzOGM2MmZjZTA1OGVkMDI0MTNmNTViMjFkMGU1ZDgzM2UyMGI3YTU2Y2QyZGRkMzQwMGUiLCJpYXQiOjE3Nzc0NTEzOTYsIm5iZiI6MTc3NzQ1MTM5NiwiZXhwIjoxODA4OTg3Mzk2LCJzdWIiOiIxNyIsInNjb3BlcyI6W119.umkLvQeYp8tbA2n9L1TJCGSyqje6eDrXPX-xfZ8oZNk7rNxoxE8U4c9HqsJcEx4P9fVnSWoE-1V711ATpQvYiB413r5oD9cqP2spzIxTjW2-PFwP481cZiusQhGULZWG05YVgW091stn-_7xQ7aCp9bPya3GksdmWcPdT-5tdPAGSLZtEhwhOhPkR6iGro8wgSGieF9S2aXVdZIwREcKEjxI7-PGoWEL5XpCGWFSuNTfbBivxu5ljpYk_3Nn-mwJQG9l1aw8zSxG_cBvHkiBr7gug0siOWbW4PETz_a2a8gzppf_UxfVmhFGKcGJZOLlpBrgwBgy-F0Z1vdwZWa38VbOUDonlY6T4AgR0cD0XyyYBuT8V88fowWm6i8wyzp1_xOyGP2RizvOBsaTDiAxUM3WNXalg52Gv3NZ3jHVCdVxwYRQ5TAoa0hhnGXnacz9fs6D_gVlKNDFqR_oDnr8ytz-aVYw4NUqXLxb0Vdw8Dke5iIq_TL99M7b0PKdotTuiuzqiE5_l5DRuUWsB3u3JW2aZg8_PnlyyOzK5heiA3XyEtncQy_CtAXT9BJQPKJnfRnDmIDrHavTtJ7BShB8x0tcWh_eVi0huXOZR8gitOkCRcczrtoHMq-aIhwC6oxNG9E28-pmjNSxp-1I80LT_a_I_x5KC1eK6iBL7C_1AKQ";
 const tokenString = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiM2NlNzk5NGFmZjlkOTc2Y2E2ZDdmNjAzYTE0MjU1OGYyZjhiMGE2ZGNkNDcyN2FiNzNiNmNkOGFmZjg4NGM2N2QyYWNhZGJkOWNmMTA5YTIiLCJpYXQiOjE3NjI4NjAxMDUsIm5iZiI6MTc2Mjg2MDEwNSwiZXhwIjoxNzk0Mzk2MTA1LCJzdWIiOiIzIiwic2NvcGVzIjpbXX0.mHqiKhycfX_muWygCpV0o76Fhnju_ibs2YQEVVOBmOf_mWwlV0afDfwbZkVsk6dcbllsKRjHl4DMUEMKqwDqbT2s12CMUt6uNGfhvCOg_XzHMWkomTMOo57dYwyQeR8DILbnJNlLsM86ZU7CXg9Qq1bNot1TWgxmDiLy_r0SzdjYWilwNgwnX5DC6lX6z6bSBIsp0I4yknpoeGJfWsLBCgVrYfoRd_vL2fkhH4IHF46jRAgiE4Erda3Kzux-nF_U2bzWCT2gqkOHWWUPkc0wG-aMPiluEryp1x8TD_gUNXLqC0WDdnR62vzoLNUA_DXPqHGnsYH1-906wBozmB-9sM7ikJ4Sym5Z6zSZ734cOrsZM5QQx3w9z8JExksQhG8xdGk1BHu-bMLYbYaFkBcXNdTMvIzm66sW9kE4L68kdT_0GnPfLYCPaOLtdvXyS9J0RYY14JbbqyVXi_0FlZx64N3OriJPxq229De5D7wJksZCVW4UR4dGuYrEWqM-aEOjzx8vzewZ0iiPR4mN91N700Eiqh8yQRsY3UO4S6z-wqm_vQlBb9bEUHlNihtbMcGcEIHNsG-AILelXZQFbI-Wx85IF2ZOu_gqAhyHWN11VdZfxWxwqtbyusgO6UtFt-ReDHk_bRU696WhR7wxePQsYwtUpgKMRnQecbZkykFOkvs";
  const aircon_url = "https://jobmaster.prismplushome.sg";
  var currentUrl = new URL(window.location.href);
  var button = document.querySelector("#submit-button");
  // Check if URL contains "circular-checkout" in path
  var isCircularCheckout = currentUrl.pathname.includes("circular-checkout");

  if (!isCircularCheckout) return;

  var sku = currentUrl.searchParams.get("sku");
  var duration = currentUrl.searchParams.get("duration");

  const url_params = Object.fromEntries(
    new URLSearchParams(window.location.search)
  );

  const utm_params = Object.fromEntries(
    Object.entries(url_params).filter(
      ([key]) => key !== "sku" && key !== "duration"
    )
  );

  // Redirect if either sku or duration is missing/empty
  if (!sku || !duration) {
    window.location.href = "/pages/neo-subscription"; 
    // change this to your target page
  }
  // If both exist, you can use them here
    console.log("SKU:", sku);
    console.log("Duration:", duration);

    fetch(aircon_url+'/api/braintree/circular_plan_details', {
      method: 'POST', // Specifies the request method
      headers: {
        'Content-Type': 'application/json', // Informs the server that the body contains JSON
        'Authorization': 'Bearer '+ tokenString // Example of an additional header
      },
      body: JSON.stringify({ 
        sku, 
        duration
      }) // The data being sent must be stringified
    })
    .then(response => response.json()) // Parses the JSON response from the server
    .then((data) => { console.log(data)
       if (data.status == true) {
        console.log(data);
        $('.total-mth').text(duration);
        $('.total-yr').text(duration / 12);
        $('.price-mth').text( theme.Currency.formatMoney(data.data.monthly_installment.toFixed(2)))
        $('.total-price').text(theme.Currency.formatMoney(data.data.total_price.toFixed(2)))
        $('.total-due').text(theme.Currency.formatMoney(data.data.deposite.toFixed(2)))
        $('.instalmen-mth').text(theme.Currency.formatMoney(data.data.monthly_installment.toFixed(2)))
        $('.system-info').text(data.data.system);
        $('.system-details').text(data.data.units + ' . ' + data.data.colour + ' . ' + data.data.btu);
        if (duration == 60) {
          $(".include-chemical").show();
          $(".service-count").text("20");
        } else {
          $(".include-chemical").hide();
          $(".service-count").text("12");
        }
        showPayment();
       }else{
         window.location.href = "/products/neo-product-subscription"; 
       }
    })
    .catch((error) => {console.error('Error:', error)});

    function showPayment(){
      fetch(aircon_url+'/api/braintree/get_client_token', {
        method: 'GET', // Specifies the request method
        headers: {
          'Content-Type': 'application/json', // Informs the server that the body contains JSON
          'Authorization': 'Bearer '+ tokenString // Example of an additional header
        },
       
      })
    .then(response => response.json()) // Parses the JSON response from the server
    .then((data) => { 
       if (data.status == true) {
        showPaymentForm(data.data.client_token)
       }else{
         window.location.href = "/products/neo-product-subscription"; 
       }
    })
  }
  function showPaymentForm(payment_token){
   
     braintree.dropin
    .create({
      authorization: payment_token,
      selector: "#dropin-container",
      dataCollector: true,
    })
    .then(function (instance) {
      button.addEventListener("click", function () {

          var formData = {
            name: $("#name").val().trim(),
            fin: $("#fin").val().trim(),
            email: $("#email").val().trim(),
            phone: $("#phone").val().trim(),
            postal_code: $("#postal_code").val().trim(),
            unit: $("#unit").val().trim(),
            address: $("#address").val().trim()
          };

         if($('#name').val().trim() == ''){
           showValidationError($('#name'), 'Name is required');
           return false;
         }else{
          removeValidationError($('#name'))
         }
         if($('#fin').val().trim() == ''){
           showValidationError($('#fin'), 'NRIC / FIC required');
           return false;
         }else{
          removeValidationError($('#fin'))
         }
         if($('#email').val().trim() == ''){
           showValidationError($('#email'), 'Email is required');
           return false;
         }else{
          removeValidationError($('#email'))
         }
         if($('#phone').val().trim() == ''){
           showValidationError($('#phone'), 'Phone is required');
           return false;
         }else{
          removeValidationError($('#phone'))
         }
         if($('#postal_code').val().trim() == ''){
           showValidationError($('#postal_code'), 'Postal Code is required');
           return false;
         }else{
          removeValidationError($('#postal_code'))
         }
         if($('#unit').val().trim() == ''){
             showValidationError($('#unit'), 'Unit - Floor is required');
             return false;
           }else{
            removeValidationError($('#unit'))
         }
         if($('#address').val().trim() == ''){
           showValidationError($('#address'), 'Address is required');
           return false;
         }else{
          removeValidationError($('#address'))
         }
        // showError("Please enter all the fields");
        // return true;

        instance.requestPaymentMethod(function (err, payload) {
          payment_checkout(
            { sku, duration },
            payload,
            instance,
            formData
          );
        });
      });
    });
  }

  function showError(message) {
    let error = "<strong>Error!</strong> " + message;
    $("#error_tag").html(error);
    $("#error_tag").css("visibility", "visible");
  }

  function hideError() {
    $("#error_tag").html("");
    $("#error_tag").css("visibility", "hidden");
  }

  function showValidationError(cObj, message) {
    $(cObj).next().remove("span");
    cObj.addClass("invalid");
    cObj.after('<span class="validation error">' + message + "</span>");
  }

  function removeValidationError(cObj) {
    $(cObj).removeClass("invalid");
    $(cObj).next().remove("span");
  }

  function payment_checkout(plan, payload, instance, formData) {
    console.log("====================================");
    console.log("payload", payload);
    console.log("====================================");

    if (!payload) {
      return false;
    }

    let params = {
      name: formData.name,
      fin: formData.fin,
      email: formData.email,
      phone: formData.phone,
      unit: formData.unit,
      postal_code: Number(formData.postal_code),
      address: formData.address,
      paymentMethodNonce: payload.nonce,
      deviceData: payload.deviceData,
      sku: plan.sku,
      duration: Number(plan.duration),
      utm_params : utm_params
    };

    fetch(aircon_url+'/api/braintree/circular_checkout', {
      method: 'POST', // Specifies the request method
      headers: {
        'Content-Type': 'application/json', // Informs the server that the body contains JSON
        'Authorization': 'Bearer '+ tokenString // Example of an additional header
      },
      body: JSON.stringify(params) // The data being sent must be stringified
    })
    .then(async (response) => {
        $(".invalid").removeClass("invalid");
        const text = await response.text();
        let data;
        
        try {
          data = JSON.parse(text);
        } catch (e) {
          throw new Error("Invalid JSON response");
        }

        if (data.status!=true) {
        // if (!response.ok) {  
          if (data.errors) {
            handleValidationErrors(data.errors); 
            throw new Error("API error"); 
          } else {
            showGlobalError(data.message || "Something went wrong");
          }
          
        }
        return data;
    })
    .then((data) => { 
      console.log(data)
      if(data.status!=true){
        instance.clearSelectedPaymentMethod();
        let error = "<strong>Payment failed!</strong> Please try again.";
        $("#error_tag").html(error);
        $("#error_tag").css("visibility", "visible");
        return;
      }
      update_thankyou(data.data, formData);
      

    })
    .catch((error) => {
      console.error("Error:", error.message);
    });

  }

  function handleValidationErrors(errors) {
    $(".invalid").remove();
    console.log("================ rr =============");
    console.log(errors);
    for (let field in errors) {
      if (field == "unit") continue;
      
      let input = $("#" + field);

      if (input.length) {
        showValidationError(input, errors[field][0]);
      }
    }
  }

  function update_thankyou(subscription, formData){
    if (checkout) checkout.style.display = "none";
    if (thankyou) thankyou.style.display = "block";
    var address = '<p class="info-title">Installation Address</p> <p><b>'+formData.name+'</b> <br/>'+formData.address+'<br/>'+formData.unit+', Singapore '+formData.postal_code+'</p>';
    var contacts = '<p class="info-title">Contact</p><p>'+formData.email+'<br/>'+formData.phone+'</p><p class="subtext">For site survey scheduling</p>';
    var deposit_amount ='Your subscription has been received and a 2-month deposit of '+'$'+subscription.deposit+' has been charged.';
    $('.address-wrapper').html(address);
    $('.contact-wrapper').html(contacts);
    $('.order-number').text(subscription.subscription_ref_id);
    $('.order-date').text(subscription.subscription_date);
    $('.cx-name').text(formData.name);
    $('.cx-email').text(formData.email);
    $('.deposit_subtext').text(deposit_amount);


  }
  if (checkout) checkout.style.display = "block";
  if (thankyou) thankyou.style.display = "none";
})();
